import React from "react";
import "./Template_2.css";

const Template_2_AboutUs = () => {
  return (
    <section id="about" className="Template_2 section">
      <div className="Template_2 container">
        <div className="Template_2 section-title">
          <h2>Our Story</h2>
          <p>Discover what makes us your ideal travel companion</p>
        </div>
        <div className="Template_2 about-content">
          <div className="Template_2 about-image">
            <img
              src="https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Travel Team"
            />
          </div>
          <div className="Template_2 about-text">
            <h3>Crafting Unforgettable Journeys</h3>
            <p>
              Since 2010, VoyageVista has been dedicated to creating exceptional
              travel experiences that go beyond the ordinary. We believe that
              travel has the power to transform lives and broaden perspectives.
            </p>
            <p>
              Our team of passionate travel designers carefully curates each
              itinerary, paying attention to every detail to ensure seamless and
              memorable experiences. From hidden gems to iconic landmarks, we
              bring you the world's most captivating destinations.
            </p>

            <div className="Template_2 about-stats">
              <div className="Template_2 stat">
                <div className="Template_2 stat-number">13+</div>
                <div className="Template_2 stat-label">Years of Excellence</div>
              </div>
              <div className="Template_2 stat">
                <div className="Template_2 stat-number">50+</div>
                <div className="Template_2 stat-label">Global Destinations</div>
              </div>
              <div className="Template_2 stat">
                <div className="Template_2 stat-number">10k+</div>
                <div className="Template_2 stat-label">Happy Travelers</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Template_2_AboutUs;
